
const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 30
    const h = 30
    return (
        <svg width={w} height={h} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M2.375 14.0625H28.625" stroke="#101010" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26.75 21.5625V24.375C26.75 24.6236 26.6512 24.8621 26.4754 25.0379C26.2996 25.2137 26.0611 25.3125 25.8125 25.3125H23C22.7514 25.3125 22.5129 25.2137 22.3371 25.0379C22.1613 24.8621 22.0625 24.6236 22.0625 24.375V21.5625" stroke="#101010" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.9375 21.5625V24.375C8.9375 24.6236 8.83873 24.8621 8.66291 25.0379C8.4871 25.2137 8.24864 25.3125 8 25.3125H5.1875C4.93886 25.3125 4.7004 25.2137 4.52459 25.0379C4.34877 24.8621 4.25 24.6236 4.25 24.375V21.5625" stroke="#101010" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 17.8125H9.875" stroke="#101010" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.125 17.8125H23" stroke="#101010" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26.75 14.0625L23.2461 6.1875C23.1734 6.0209 23.0538 5.87903 22.9019 5.77916C22.75 5.67929 22.5724 5.62573 22.3906 5.625H8.60937C8.4276 5.62573 8.24996 5.67929 8.09807 5.77916C7.94619 5.87903 7.82662 6.0209 7.75391 6.1875L4.25 14.0625V21.5625H26.75V14.0625Z" stroke="#101010" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default SvgComponent
